export const config = () => {
  const token = localStorage.getItem("token");
  return {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json", // Defina o tipo de conteúdo conforme necessário
    },
  };
};
